export default __webpack_public_path__ + "static/messages-section-messages-d404d655f3ceec860f57a34beb67af7e.png";